<template>
  <div class="fan fan-component">
    <template v-if="image">
      <div v-if="disableEdit" style="margin-bottom: 10px;">
        <a-button size="small" @click="getLayoutInfo" type="primary">确认布局</a-button>
        <a-button size="small" @click="$refs.indoorMarker.addBlockLocalIcon('fire')">添加消防栓</a-button>
        <a-button size="small" @click="$refs.indoorMarker.addBlockLocalIcon('video')">添加视频监控</a-button>
        <a-button size="small" @click="$refs.indoorMarker.addBlockLocalIcon('exit')">添加安全出口</a-button>
        <a-button size="small" @click="$refs.indoorMarker.addBlockLocalIcon('water')">添加自动喷淋</a-button>
      </div>
      <IndoorMarker ref="indoorMarker"
                    width="100%"
                    height="auto"
                    :value="value"
                    :backgroundImage="{
                      url: image,
                      width: '100%',
                      height: 'auto'
                    }" />
    </template>
    <div v-else style="color: #86909c; padding: 20px; text-align: center; background: #f7f8fa; border-radius: 4px;">
      请先上传平面图
    </div>
  </div>
</template>

<script>
import IndoorMarker from './IndoorMarker.vue'

export default {
  name: 'FIndoorMarker',
  components: { IndoorMarker },
  props: {
    disableEdit: Boolean,
    image: String,
    name: String,
    value: {
      type: Array,
      default: () => []
    }
  },
  methods: {
    getLayoutInfo() {
      const layoutInfo = this.$refs.indoorMarker.getLayoutInfo()
      const blocks = JSON.parse(JSON.stringify(layoutInfo.blocks))
      this.$emit('change', this.name, blocks)
    }
  }
}
</script>

<style scoped>
</style>
